export function parseAspect(aspect: string, custom: string | null): number | null {
  switch (aspect) {
    case 'a_16_9':
      return 16 / 9;
    case 'a_9_16':
      return 9 / 16;
    case 'a_4_3':
      return 4 / 3;
    case 'a_3_4':
      return 3 / 4;
    case 'a_1_1':
      return 1;
    case 'custom': {
      if (!custom) return null;
      const m = /^(\d+):(\d+)$/.exec(custom);
      if (!m) return null;
      const w = Number(m[1]);
      const h = Number(m[2]);
      return h > 0 ? w / h : null;
    }
    default:
      return null;
  }
}
